import React from 'react';

const Header = ({ onMenuToggle, onHomeClick }) => {
  return (
    <header className="temple-header-modern">
      <div className="header-container">
        <button className="menu-trigger" onClick={onMenuToggle} aria-label="Menu">
          <div className="hamburger-bar"></div>
          <div className="hamburger-bar shorter"></div>
        </button>
        
        <div className="header-branding" onClick={onHomeClick}>
          <img src="/nama-hg-rb.png" alt="Nama" className="header-nama-logo" />
          <div className="header-titles">
            <h1>శ్రీ సీతారామచంద్రస్వామి వారి దేవస్థానం</h1>
            <h2 className="reconstruction-subtitle">పునర్నిర్మాణ మహాయజ్ఞం</h2>
            <p>వామకుంట్ల గ్రామం</p>
          </div>
        </div>

        <div className="header-icons-set">
          <img src="/shank.png" alt="Shank" className="branding-icon" />
          <img src="/chekra.png" alt="Chakra" className="branding-icon" />
        </div>
      </div>
    </header>
  );
};

export default Header;
